import React from 'react';
import'./Header.css'
import CTA from './CTA'
// import ME from '../../assets/me.png';
import ME from '../../assets/me-2.png';
import HeaderSocials from './HeaderSocials';
import { TypeAnimation } from "react-type-animation"
import {motion} from "framer-motion"
const Header = () => {

    const intro ={
        hidden: {opacity: 0},
        visible: {opacity: 1, transition: {
            duration: 0.5,
            staggerChildren: 0.25,
            delayChildren: 1
        }},
    }
    
    const introChildren = {
        hidden: {opacity: 0, y: -300},
        visible: {opacity: 1, y: 0, transition: {
            duration: 1.3,
            type: "spring",
            bounce: 0.5
        }}
    }
    
    const image = {
        initial: {y: 0, rotate:360, transition: {duration: 10}},
        animate: {y: 20, transition: {
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
            rotate: 0
        }}
    }
    




    return (
        <header>
           <div className="container header_container">
            <h5>Hello I'm</h5>
            <h1>Joyanti Chowdhury</h1>
            {/* <h5 className="text-light">
                Full Stack Web Developer
            </h5> */}
            <div className="text-sm lg:text-2xl text-myGreen font-bold lg:mt-6 mt-2 mb-4">
                            <TypeAnimation
                                sequence={[
                                    'a Web Designer.',
                                    1000,
                                    'a  Web Developer.',
                                    1000,
                                    'a Professional Coder.',
                                    1000,
                                    'a MERN Stack Developer.',
                                    1500,
                                    'a React Developer.',
                                    1000,
                                    'a Next.js Developer.',
                                    1000,
                                    'a Frontend Developer.',
                                    1000,
                                    'a Full Stack Developer.',
                                    1000
                                ]}
                                wrapper="span"
                                speed={50}
                                style={{ fontSize: '2em', display: 'inline-block' }}
                                repeat={Infinity}
                            />
                        </div>

            <CTA></CTA>
            <HeaderSocials></HeaderSocials>


            <motion.div className="me" variants={image} initial="initial" animate="animate" >
                <img className='h-[500px] w-full' src={ME} alt="me" />
            </motion.div>
            <a href="#contact" className='scroll_down'>Scroll Down</a>
           </div>
          
        </header>
    
    );
};

export default Header;

// import React from 'react'


//  const Header = () => {
//   return (
//     <div>Header</div>
//   )
// }
// export default Header;
